import { Component, Injectable, Input, OnInit, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseGeneralComponent } from 'src/app/BaseGeneralComponent';
import { UsersService } from 'src/app/users/service/users.service';
import { ProviderModel } from 'src/models/ProviderModel';

@Injectable()
@Component({
  selector: 'app-billing-tab',
  templateUrl: './billing-tab.component.html',
  styleUrls: ['./billing-tab.component.scss']
})
export class BillingTabComponent extends BaseGeneralComponent implements OnInit, PipeTransform {
  selectedIndex: any;
  sectionId: string;
  @Input() reportSection?: boolean;

  providerSelected: ProviderModel;
  constructor(private _Activatedroute: ActivatedRoute,
              private userService: UsersService) {
    super();
    this.sectionId = this.SECTIONS.BILLING;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    _Activatedroute.queryParams.subscribe(params => {
      this.selectedIndex = params['selectedIndex'];
    });
  }

  ngOnInit() {
    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });

      this.providerSelected = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
      
  }

  transform(items: any[], field: string, value: string): any[] {
    if (!items) {
      return [];
    }
    if (!field || !value) {
      return items;
    }

    return items.filter(singleItem =>
      singleItem[field].toLowerCase().includes(value.toLowerCase())
    );
  }

}
